module.exports = __webpack_public_path__ + "static/media/dishWasherIcon.cc61364d.svg";